export default __webpack_public_path__ + "static/generate-host-e225e59ecd6f319c803c50d6d39565d1.png";